import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAdminReviews, fetchAdminReviews } from "./AdminReviewsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchAdminReviewsAsync = createAsyncThunk(
  "AdminReviews/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchAdminReviews();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteAdminReviewsAsync = createAsyncThunk(
  'AdminReviews/delete',
  async ({uuid}, { rejectWithValue }) => {
    try {
      await deleteAdminReviews(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AdminReviewsSlice = createSlice({
  name: "AdminReviews",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminReviewsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminReviewsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchAdminReviewsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(deleteAdminReviewsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdminReviewsAsync.fulfilled, (state, action) => {
        state.loading = false; 
        state.data = state.data.filter(
          (cityData) => cityData.id !== action.payload
        );
      })
      .addCase(deleteAdminReviewsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectAdminReviews = (state) => state.adminReviews.data;

export default AdminReviewsSlice.reducer;
